module.exports = __webpack_public_path__ + "static/media/33-5.d338c674.mp3";